"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    explore: {
        path: "/explore"
    },
    guestHome: {
        path: "/"
    },
    getHelp: {
        path: "/properties/get-help"
    },
    noProperty: {
        path: "/properties/no-property"
    },
    guestDocumentUploadDetail: {
        path: "/file/:id"
    },
    guestDocumentUploadFile: {
        path: "/view-file/:id"
    },
    guestElevationCertificates: {
        path: "/elevation-certificates"
    },
    guestUploadElevationCertificates: {
        path: "/upload-elevation-certificates"
    },
    residentProperty: {
        path: "/properties/:propertyId"
    },
    residentPropertyRedirect: {
        path: "/properties"
    },
    residentSavedView: {
        path: "/view/:savedViewId"
    },
    residentCustomObject: {
        path: "/objects/:customMapId/:geometryId"
    },
    myRecords: {
        path: "/my-records"
    },
    signupConfirmation: {
        path: "/signup-confirmation"
    },
    requestEmailConfirmation: {
        path: "/request-email-confirmation"
    },
    acceptPublicUserInvite: {
        path: "/accept-invite/:inviteId"
    }
});

//# sourceMappingURL=data:application/json;base64,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